"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference types="@speedlo/types" />
var Sentry = __importStar(require("@sentry/browser"));
var apollo_client_1 = require("apollo-client");
var react_1 = __importDefault(require("react"));
var verror_1 = __importDefault(require("verror"));
var ApolloOperationError_1 = require("./ApolloOperationError");
var apolloDefender = react_1.default.createContext(undefined);
exports.ApolloDefender = function (_a) {
    var onUserErrors = _a.onUserErrors, onNetworkError = _a.onNetworkError, onOperationError = _a.onOperationError, _b = _a.reportNetworkFailure, reportNetworkFailure = _b === void 0 ? false : _b, children = _a.children;
    var onError = react_1.default.useCallback(function (error) {
        if (apollo_client_1.isApolloError(error) && error.networkError) {
            var unreach = isNetworkUnreachableError(error);
            if (!unreach && reportNetworkFailure) {
                Sentry.withScope(function (scope) {
                    scope.setLevel(Sentry.Severity.Debug);
                    Sentry.captureException(new verror_1.default(error.networkError, 'Network failure'));
                });
            }
            if (onNetworkError) {
                onNetworkError(error.networkError, unreach);
            }
            return;
        }
        if (ApolloOperationError_1.isOperationError(error)) {
            var showToUser_1 = getUserErrors(error);
            if (onUserErrors && showToUser_1.length > 0) {
                onUserErrors(showToUser_1);
                return;
            }
            if (onOperationError) {
                onOperationError(error);
            }
            Sentry.withScope(function (scope) {
                scope.setTag('apolloError', error.operationType + "Error");
                scope.setExtra('showToUser', showToUser_1);
                scope.setExtra('errors', error.graphQLErrors
                    .filter(function (err) { return !showToUserPredicate(err); })
                    .map(function (err) { return ({
                    message: err.message,
                    origMessage: err.originalError
                        ? err.originalError.message
                        : undefined,
                    path: err.path,
                }); }));
                if (error.operationName) {
                    scope.setExtra('operationName', error.operationName);
                }
                scope.setExtra('operationVariables', error.operationVariables);
                Sentry.captureException(new verror_1.default(error, error.operationType + " " + error.operationName + " failed"));
            });
            return;
        }
        Sentry.captureException(error);
    }, [onNetworkError, onOperationError, onUserErrors, reportNetworkFailure]);
    return (react_1.default.createElement(apolloDefender.Provider, { value: { onError: onError } }, children));
};
exports.useApolloDefender = function () {
    var ctx = react_1.default.useContext(apolloDefender);
    if (!ctx) {
        throw new Error('ApolloDefender is missing in the tree');
    }
    return ctx;
};
exports.useApolloDefenderReporter = function (error, query, variables) {
    var onError = exports.useApolloDefender().onError;
    react_1.default.useEffect(function () {
        if (error) {
            onError(new ApolloOperationError_1.ApolloOperationError(error, query, variables));
        }
    }, [onError, error, query, variables]);
};
function isNetworkUnreachableError(error) {
    return (error.networkError !== null &&
        (error.networkError.message === 'Failed to fetch' ||
            error.networkError.message.indexOf('Unexpected end of JSON input') >= 0 ||
            error.networkError.message.indexOf('unexpected end of data') >= 0));
}
exports.isNetworkUnreachableError = isNetworkUnreachableError;
function isChunkError(error) {
    return (error.message &&
        (error.message.indexOf('Loading chunk') >= 0 ||
            error.message.indexOf('Loading CSS chunk') >= 0));
}
exports.isChunkError = isChunkError;
function showToUserPredicate(error) {
    return Boolean(error.extensions && error.extensions.showToUser);
}
exports.showToUserPredicate = showToUserPredicate;
function getUserErrors(error) {
    return error.graphQLErrors.filter(showToUserPredicate).reduce(function (acc, err) {
        return __spread(acc, [err.message]);
    }, []);
}
exports.getUserErrors = getUserErrors;
//# sourceMappingURL=ApolloDefender.js.map